// CARTO basemap tiles. As of 2025 CARTO requires an API key on their basemap
// CDN; without it tiles render with an "API Key Required" watermark.
//
// This key ships in the client bundle by design — CARTO basemap keys are
// public/domain-scoped, not secrets. Set REACT_APP_CARTO_KEY at build time to
// override it without touching source.
export const CARTO_KEY =
  process.env.REACT_APP_CARTO_KEY || 'cb1_32f1_1_b4e62e1846d39af43ac55006';

export const CARTO_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>';

/** Tile URL template for a CARTO basemap style, e.g. 'light_all', 'rastertiles/voyager'. */
export const cartoTileUrl = (style: string) =>
  `https://{s}.basemaps.cartocdn.com/${style}/{z}/{x}/{y}{r}.png?key=${CARTO_KEY}`;
